export const MAIN_JOB_WORKING_WORLD_CATEGORIES = [
  { label: 'Einkauf & Handel' },
  { label: 'Governance' },
  { label: 'Human Resources' },
  { label: 'Informationstechnologie' },
  { label: 'Ingenieurwesen' },
  { label: 'Management' },
  { label: 'Marketing & Kommunikation' },
  { label: 'Nachwuchskräfte' },
  { label: 'Projekt- & Prozessmanagement' },
  { label: 'Services' },
  { label: 'Technik' },
  { label: 'Umwelt-, Gesundheits- und Arbeitsschutz' },
  { label: 'Unternehmenssteuerung' },
  { label: 'Vertrieb' },
];
